export default {
  REASON_IS_NOT_AVAILABLE_FOR_SUPPORT: 'Not available for support',
  REASON_IS_NOT_AVAILABLE_FOR_TELEGRAM_BOT: 'Not available for telegram bot',
  REASON_NOT_ENOUGH_PERMISSIONS: 'Not enough permissions',
  REASON_AVAILABLE_FOR_ANONYMOUS_USERS: 'Not available for anonymous users',
  REASON_GENERAL_DISALLOW: 'General disallow',
  REASON_RESTRICTED_BY_FEATURE: 'Restricted by feature',
} as const;
